import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { NzListModule } from 'ng-zorro-antd/list';
import { environment } from '@app/environments/environment';

@Component({
  selector: 'app-about-popup',
  imports: [
    NzIconModule,
    NzListModule,
  ],
  templateUrl: './about-popup.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './about-popup.component.scss',
})
export class AboutPopupComponent {
  aboutData: any = {};
  currentYear = new Date().getFullYear();
  constructor() {
    this.aboutData = environment;
  }
}
